import { Component, Input } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AbstractComponent } from '../../components/abstract-component/abstract.component';
import { ListLoader } from '../../components/list-loader/list-loader';
import { GrundstueckFlaechenanteilMasterDetailEntry, GrundstueckId } from '../../../core/av-api';
import { NavTarget } from '../../components/link/link.component';
import { ListLoaderWrapperComponent } from '../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../directives/history.directive';
import { KompaktGrundstueckComponent } from '../../kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { KompaktTimepointComponent } from '../../kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DecimalHochkommaPipe } from '../../pipes/simple/decimalHochkomma.pipe';

@Component({
  selector: 'cap-flaechenanteil-table',
  templateUrl: './flaechenanteil-table.component.html',
  imports: [
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    NgStyle,
    HistoryDirective,
    KompaktGrundstueckComponent,
    KompaktTimepointComponent,
    TranslatePipe,
    DecimalHochkommaPipe
  ]
})
export class FlaechenanteilTableComponent extends AbstractComponent {
  @Input()
  hasRight = true;

  @Input()
  showTotal = false;

  @Input()
  showZeilenSelect = false;

  @Input()
  showFlaeche = true;

  @Input()
  listLoader: ListLoader<GrundstueckFlaechenanteilMasterDetailEntry>;

  @Input()
  grundstueckId: GrundstueckId;

  @Input()
  navigateTo = NavTarget.NAV_GRUNDSTUECK;

  constructor() {
    super();
    keysToTranslate<string>(['Art', 'Grundstueck', 'Abschnittflaeche', 'LastetAuf', 'BelastetMit']);
  }
}
